export default __webpack_public_path__ + "static/media/RobotoMono-Thin.b6edbbf2.woff";